module.exports = __webpack_public_path__ + "img/glm_gbt6180_1986.prt.f087b16c.jpg";